import LoadingButton from '@mui/lab/LoadingButton';
import { useFeatures } from '@utils/hooks';

type ExecutiveReportDownloadButtonProps = {
  loading: boolean;
  onClickHandler: () => void;
  disabled?: boolean;
};

export const ExecutiveReportDownloadButton = ({
  loading,
  onClickHandler,
  disabled,
}: ExecutiveReportDownloadButtonProps) => {
  const features = useFeatures();

  return (
    <LoadingButton
      onClick={onClickHandler}
      size="large"
      disabled={disabled}
      loadingPosition="start"
      loading={loading}
      // workaround to avoid loading icon overlap without a startIcon
      startIcon={loading ? '...' : undefined}
    >
      <span>
        {features.pptRedesign
          ? 'End of Campaign Report (.pptx)'
          : 'Executive Report (.pptx)'}
      </span>
    </LoadingButton>
  );
};
